import { getPromotionMinLos } from 'selectors/bedbankOfferSelectors'
import { useAppSelector } from './reduxHooks'

function useBedbankOfferSell(
  offer: App.BedbankOffer | App.BedbankOfferSummary,
  duration: number,
): App.BedbankSellPriceInfo | null {
  const promotionMinLos = useAppSelector((_state) => getPromotionMinLos({ bedbankOffer: offer as App.BedbankOffer }))

  const hasPromotions = offer.promotions.length > 0

  if (hasPromotions && offer.sell && promotionMinLos <= duration) {
    const price = Math.round((offer.sell.price / offer.sell.los) * duration)
    const value = Math.round((offer.sell.value / offer.sell.los) * duration)
    const discount = Number(((offer.sell.value - offer.sell.price) / offer.sell.value).toFixed(2))
    return {
      price,
      value,
      discount: discount > 0.02 ? discount : 0,
      los: duration,
    }
  }

  return null
}

export default useBedbankOfferSell
